import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {HelperService} from '../helper.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';

@Component({
	selector: 'kt-new-helper',
	templateUrl: './new-helper.component.html',
	styleUrls: ['./new-helper.component.scss']
})
export class NewHelperComponent implements OnInit {
	@Input() public id;
	form = this.fb.group({
		name: ['', Validators.required],
		description: ['', Validators.required],
		link: ['', Validators.required],
		visibleByAdmin: [],
		visibleBySupervisor: [],
		visibleBySubSupervisor: [],
		visibleByUser: [],
		visibleByCassa: [],
	});

	constructor(private service: HelperService, public activeModal: NgbActiveModal, private toastr: ToastrService, private fb: FormBuilder) {
	}

	ngOnInit() {
		if (this.id) {
			this.service.getHelp(this.id).subscribe(resp => {
				this.form.setValue({
					name: resp.name,
					description: resp.description,
					link: resp.link,
					visibleByAdmin: resp.visibleByAdmin,
					visibleBySupervisor: resp.visibleBySupervisor,
					visibleBySubSupervisor: resp.visibleBySubSupervisor,
					visibleByUser: resp.visibleByUser,
					visibleByCassa: resp.visibleByCassa,
				});
			});
		}
	}


	save() {
		if (!this.id) {
			this.service.newHelper(this.form.getRawValue()).subscribe((res) => {
				if (res.status == 200) {
					this.toastr.success('A segédletet sikeresen hozzáadta', '');
					this.activeModal.close(true);
				} else {
					this.toastr.error('Hiba létrehozás közben', 'Hiba');
				}
			}, (error) => {
				this.toastr.error(error.error.message, 'Hiba');
			});
		} else {
			this.service.modifyHelper(this.id, this.form.getRawValue()).subscribe((res) => {
					if (res.status == 200) {
						this.toastr.success('A segédletet sikeresen frissítette', '');
						this.activeModal.close(true);
					} else {
						this.toastr.error('Hiba történt!', '');
					}
				}, (error => {
					this.toastr.error(error.error.message, 'Hiba');
				})
			);
		}
	}
}
